export default "__VITE_ASSET__ab63f0b6__"